<template>
  <div class="mycontaine">
    <div class="myheadertwi" >
      <p style="display: flex;align-items: center;margin-bottom: 0.08rem;font-size: 0.5rem">
        Lv.{{userinfo.inGrade.name}}
      </p>
      <p style="width: 90%;display: flex;justify-content: space-between;margin-left: 0;font-size: 0.25rem">
        <span v-if="userinfo.inGrade.discount<10">本月享运费：{{ userinfo.inGrade.discount }}折</span>
        <span v-else>本月享运费：无折扣</span>
        <span>本月已消费：{{ userinfo.monthTotalPrice }}</span>
      </p>

    </div>

    <div style="width: 100%; height: 3.1rem"></div>
     <div class="lsiennr">
       <div class="toptitek">
         <span>升级及保级规则</span>
       </div>
       <div class="lsiennrsue">
         <div class="lisitenr">
           <div class="topcpayenr">
             <div class="labenkr" style="width: 20%">
               <span>等级</span>
             </div>
             <div class="labenkr">
               <span>保级消费额</span>
             </div>
             <div class="labenkr">
               <span>升级消费额</span>
             </div>
             <div class="labenkr">
               <span>权益</span>
             </div>
           </div>
           <div class="topcpayenr" v-for="(item,index) in userinfo.listGrade" :key="index" style="background-color: #ffffff">
             <div class="labenkr" style="width: 20%;background-color: #e8e8e8">
               <span>{{item.name}}</span>
             </div>
             <div class="labenkr">
               <span>{{item.holdGradeMoney}}</span>
             </div>
             <div class="labenkr">
               <span>{{item.upGradeMoney}}</span>
             </div>
             <div class="labenkr">
               <span v-if="item.discount<10">{{item.discount}}折</span>
               <span v-else>无折扣</span>
             </div>
           </div>

         </div>
         <div style="margin-top: 0.2rem;font-size: 0.25rem;text-align: left;line-height: 0.5rem; padding-bottom: 0.2rem;display: flex;justify-content: flex-start;width: 96%;margin-left: 2%;white-space: pre-line;">
           <span>{{userinfo.gradeExplain}}</span>
         </div>
       </div>
     </div>


    <div style="height:1rem"></div>
  </div>
</template>

<script>
import { Dialog, Field, CellItem, Icon, Toast,Tag ,Button} from "mand-mobile";
import {getUrlKey} from "@/until/getUrlcode";

export default {
  name: "My",
  components: {
    [Dialog.name]: Dialog,
    [Field.name]: Field,
    [CellItem.name]: CellItem,
    [Icon.name]: Icon,
    [Tag.name]: Tag,
    [Button.name]: Button,
  },
  data() {
    return {
      credit: 0,
      couop: 0,
      account: 0,
      url:'',
      userinfo: {},

    };
  },

  activated() {
    if(getUrlKey("cnm", window.location.href)) {
      Toast.loading('加载中...');
      // debugger
      localStorage.setItem('mupressMobiltoken', getUrlKey("cnm", window.location.href));
      var that = this;
      setTimeout(function () {
        that.getUserGradeInfo()
      }, 20)
    }else{
      this.getUserGradeInfo()
    }

  },
  methods: {
    getUserGradeInfo(){
      this.http.APIASK(this.ports.getUserGradeInfo, "get").then(res => {
        this.userinfo = res;
        Toast.hide()
      });
    },
  }
};
</script>
<style lang="less">

.mycontaine {
  background-color: #ffffff;
  .myheadertwi {
    width: 96%;
    margin-left: 2%;
    border-radius: 0.16rem;
    height: 2.3rem;
    background-color: #e32c1a;
    position: fixed;
    top: 0.4rem;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    font-size: 0.3rem;
    color: white;
    z-index: 999;
    p {
      margin-left: 0.5rem;
      margin-top: 0.5rem;
    }
    span {
      margin-left: 0.5rem;
    }
    img {
      margin-left: 0.5rem;
      width: 0.5rem;
      margin-bottom: -0.1rem;
    }
    .userinfo {
      position: absolute;
      top: 2.1rem;
      height: 1.5rem;
      width: 94%;
      margin-left: 3%;
      background-color: white;
      border-radius: 0.15rem;
      display: flex;
      justify-content: space-around;
      align-items: center;
      p {
        font-size: 0.4rem;
        color: #f44444;
        margin-left: 0.2rem;
        margin-top: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        span {
          color: #999999;
          margin: 0;
          font-size: 0.3rem;
          margin-top: 0.1rem;
        }
      }
    }
  }
  .lsiennr{
    width: 96%;
    margin-left: 2%;
    border-top-right-radius: 0.1rem;
    border-top-left-radius: 0.1rem;
    overflow: hidden;
    .toptitek{
      width: 100%;
      height: 0.8rem;
      background-color: #e32c1a;
      font-size: 0.3rem;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      color: #ffffff;
       span{
         margin-left: 0.3rem;
       }
    }
    .lsiennrsue{
      border: 1px solid #e4e4e4;
      .lisitenr{
        width: 96%;
        margin-left: 2%;
        margin-top: 0.3rem;
        background-color: #e8e8e8;

        .topcpayenr{
          width: 100%;
          display: flex;
          font-size: 0.26rem;
          color: #333333;
          font-weight: 500;
          border-bottom: 1px solid #d8d8d8;
          .labenkr{
            width: 25%;
            height: 0.8rem;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            span{
              margin-left: 0.1rem;
            }
          }
        }
      }
    }
  }
}
</style>
